import { useEffect, useState } from "react";
import { Card, Button, Input, Text } from "@nextui-org/react";
import {
  TbSortAscending,
  TbSortDescending,
  TbEdit,
  TbTrash,
  TbSearch,
} from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const HistoryTable = (props) => {
  const token = useSelector((state) => state.invtry.token);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [currentSort, setCurrentSort] = useState({
    field: "name",
    asc: false,
  });
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const changeCurrentSort = (field, asc) => {
    setCurrentSort({ field: field, asc: asc });
  };

  const deleteHandler = async (id, type) => {
    await fetch("https://stockmanager-api.vercel.app/delete-product", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        type,
        alt: props.dbFilter === "alt",
        sunil: props.dbFilter === "sunil",
        threeH: props.dbFilter === "threeH",
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.success) {
          return setLoading(false);
        }

        window.alert("SUCCESS");
        props.load();
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        window.alert("An error occured, please try again.");
        return setLoading(false);
      });
  };

  useEffect(() => {
    console.log(props.list);
    if (props.list?.length > 0) {
      let listCopy = [...props.list];
      let sortCurrent;

      const regex = new RegExp(search, "i");

      if (search !== "") {
        listCopy = listCopy?.filter((doc) => {
          return (
            regex.test(doc?.name) ||
            regex.test(doc?.type) ||
            regex.test(doc.desc)
          );
        });
      }

      if (currentSort.field === "name") {
        sortCurrent = listCopy.sort((a, b) => {
          let fa = a?.name;
          let fb = b?.name;
          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        });
      } else if (currentSort.field === "type") {
        sortCurrent = listCopy.sort((a, b) => {
          let fa = a?.type;
          let fb = b?.type;
          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        });
      } else {
        sortCurrent = listCopy.sort((a, b) => {
          return (sortCurrent = listCopy.sort((a, b) => {
            let fa = a?.desc;
            let fb = b?.desc;
            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          }));
        });
      }

      setList(currentSort.asc ? sortCurrent : sortCurrent.reverse());
    } else {
      setList([]);
    }
  }, [currentSort, props.list, search]);

  return (
    <div style={{ width: "100%", maxWidth: "1200px", padding: "10px" }}>
      {/* Search and Sort controls */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          gap: "15px",
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        <div style={{ flex: 1, minWidth: "260px", maxWidth: "400px" }}>
          <Input
            bordered
            fullWidth
            contentLeft={<TbSearch size={18} style={{ color: "#adb5bd" }} />}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search products..."
            clearable
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            flexWrap: "wrap",
          }}
        >
          <Text size={14} weight="semibold" style={{ color: "#495057" }}>
            Sort by:
          </Text>
          <Button
            auto
            size="sm"
            onClick={() => changeCurrentSort("name", !currentSort.asc)}
            icon={
              currentSort.field === "name" ? (
                currentSort.asc ? (
                  <TbSortAscending size={16} />
                ) : (
                  <TbSortDescending size={16} />
                )
              ) : (
                <TbSortAscending size={16} style={{ color: "#adb5bd" }} />
              )
            }
            css={{
              backgroundColor:
                currentSort.field === "name" ? "#e3faf2" : "#f1f3f5",
              color: currentSort.field === "name" ? "#0ca678" : "#495057",
              fontWeight: currentSort.field === "name" ? "bold" : "normal",
              border:
                currentSort.field === "name"
                  ? "1px solid #0ca678"
                  : "1px solid transparent",
              p: "0 12px",
            }}
          >
            Name
          </Button>
          <Button
            auto
            size="sm"
            onClick={() => changeCurrentSort("type", !currentSort.asc)}
            icon={
              currentSort.field === "type" ? (
                currentSort.asc ? (
                  <TbSortAscending size={16} />
                ) : (
                  <TbSortDescending size={16} />
                )
              ) : (
                <TbSortAscending size={16} style={{ color: "#adb5bd" }} />
              )
            }
            css={{
              backgroundColor:
                currentSort.field === "type" ? "#e3faf2" : "#f1f3f5",
              color: currentSort.field === "type" ? "#0ca678" : "#495057",
              fontWeight: currentSort.field === "type" ? "bold" : "normal",
              border:
                currentSort.field === "type"
                  ? "1px solid #0ca678"
                  : "1px solid transparent",
              p: "0 12px",
            }}
          >
            Type
          </Button>
        </div>
      </div>

      {/* Responsive List / Card Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(285px, 1fr))",
          gap: "15px",
          width: "100%",
        }}
      >
        {list?.map((doc) => (
          <Card
            key={doc._id}
            variant="flat"
            css={{
              padding: "15px",
              borderRadius: "14px",
              backgroundColor: "#f8f9fa",
              border: "1px solid #e9ecef",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "start",
                height: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  textAlign: "start",
                }}
              >
                <Text
                  h6
                  style={{
                    margin: 0,
                    fontWeight: 700,
                    fontSize: "16px",
                    color: "#212529",
                  }}
                >
                  {doc?.name}
                </Text>
                <div
                  style={{
                    display: "inline-block",
                    padding: "2px 8px",
                    background: "#e3faf2",
                    color: "#0ca678",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontWeight: 600,
                    width: "fit-content",
                  }}
                >
                  {doc?.type}
                </div>
              </div>
              <div style={{ display: "flex", gap: "8px" }}>
                <Button
                  auto
                  size="sm"
                  onClick={() =>
                    navigate(
                      `/analytics/edit/${doc._id}?type=${doc.type}&list=${props.dbFilter || "main"}`,
                    )
                  }
                  icon={<TbEdit size={16} />}
                  css={{
                    backgroundColor: "#e9ecef",
                    color: "#495057",
                    p: "0 10px",
                  }}
                />
                <Button
                  auto
                  color="error"
                  size="sm"
                  disabled={loading}
                  onClick={() => {
                    if (
                      window.confirm(
                        "Are you sure you want to delete this product",
                      )
                    ) {
                      deleteHandler(doc._id, doc.type);
                    }
                  }}
                  icon={<TbTrash size={16} />}
                  css={{ p: "0 10px" }}
                />
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default HistoryTable;
